<template>
  <b-modal hide-footer id="select-timezone-modal" size="lg" title="Select Timezone">


    <!-- Filters -->
    <div class="row mb-3">
      <div class="col-sm-8">
        <b class="mr-1">Current timezone:</b><br>
        {{ timezone ? timezone : "Can't determine timezone - please select" }}
      </div>
      <div class="col-sm-4">
        <div class="search-box mr-2 mb-2 d-inline-block w-100">
          <div class="position-relative">
            <input v-model="searchQuery" type="text" class="form-control" placeholder="Search..."/>
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- / Filters -->

    <!-- Table -->
    <div class="table-responsive mb-0 timezones-table">
      <table class="table mb-0 table-centered">
        <tbody>
        <tr v-for="tz in allTimezones">
          <th scope="row">{{ tz }}</th>
          <td class="text-right">
            <button v-if="!isTimezoneSelected(tz)"
                    type="button"
                    class="btn btn-itg btn-itg btn-sm"
                    @click="setTimezone(tz)"
            >
              Select
            </button>
            <button v-else type="button" class="btn btn-itg btn-sm" disabled>
              Selected
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <!-- / Table -->

  </b-modal>
</template>

<script>
export default {
  name: "SelectTimezoneModal",
  data() {
    return {
      timezone: null,
      searchQuery: ''
    }
  },
  created() {
    const timezone = window.itgTimezone;
    if (timezone) {
      this.timezone = timezone;
    }
  },
  computed: {
    allTimezones() {
      let timezones = window.moment.tz.names();
      return timezones.filter(tz => {
        return tz.toLowerCase().includes(this.searchQuery.toLowerCase())
      });
    }
  },
  methods: {
    setTimezone(timezone) {
      window.itgTimezone = timezone;
      localStorage.setItem('itgTimezone', timezone);
      this.timezone = timezone;
      this.$bvModal.hide('select-timezone-modal');
      this.$notify.success({
        title: 'Success!',
        message: 'Timezone updated successfully'
      });
      window.location.reload();
    },

    isTimezoneSelected(tz) {
      return this.timezone === tz;
    }
  }
}
</script>

<style>
.timezones-table {
 max-height: 450px;
  overflow-y: scroll;
}
</style>